export default "__VITE_ASSET__BindM3a5__"